export enum DateRange {
  Today = 'today',
  Last7Days = 'last7days',
  Last30Days = 'last30days',
}
